import React from 'react';
import Layout from 'layout/Layout';
import ReservationConfirmComponent from 'components/ReservationConfirmComponent';

const ReservationConfirmPage: React.FC = () => {
  const pageTitle = '予約確認';

  return (
    <Layout pageTitle={pageTitle}>
      <ReservationConfirmComponent></ReservationConfirmComponent>
    </Layout>
  );
};
export default ReservationConfirmPage;
